<template>
    <div class="base_box">
        <!-- 只保留添加礼物按钮 -->
        <div class="searchHead484848">
            <div class="searchForm">
                <el-form class="searchComponentsForm">
                    <el-form-item>
                        <el-button type="primary" class="btnsty base_but_style base_search_create" @click="addFun">+添加礼物</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="mt10 base_content">
            <baseTable :loading="search.loading" :total="search.total" :page="search.post.page" :list="search.table"
                :tableList="search.tableForm" :pagesize="search.post.limit" @changePage="handlePageChange">
                <template #image="scope">
                    <el-image 
                        style="width: 60px; height: 60px"
                        :src="typeof scope.row.image === 'object' ? scope.row.image.url : scope.row.image" 
                        :preview-src-list="[typeof scope.row.image === 'object' ? scope.row.image.url : scope.row.image]">
                    </el-image>
                </template>
                <!-- 状态列已注释 -->
                <!-- <template #status="scope">
                    <el-switch 
                        :value="scope.row.status == 1" 
                        @change="handleStatusChange(scope.row.id, $event)"
                    ></el-switch>
                </template> -->
                <template #price="scope">
                    <span>{{ scope.row.price || 0 }}</span>
                </template>
                <template #vote_num="scope">
                    <span>{{ scope.row.vote_num || 0 }}</span>
                </template>
                <template #operation="scope">
                    <el-button type="text" @click="editFun(scope.row)">编辑</el-button>
                    <el-button type="text" @click="deleteFun(scope.row)">删除</el-button>
                </template>
            </baseTable>
        </div>

        <!-- 添加/编辑弹窗 -->
        <el-dialog title="礼物设置" :visible.sync="dialogShow" width="500px">
            <div class="gift-rules">
                <p>1.礼物可以设置积分进行兑换，届时将不进行消耗积分，改由前端根据视频赠送礼物。</p>
                <p>2.粉丝礼物也可以设置0额度。</p>
            </div>
            <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="礼物名称：">
                    <el-input v-model="form.name" placeholder="请输入礼物名称"></el-input>
                </el-form-item>
                <el-form-item label="图片：">
                    <div class="goodsimage">
                        <div class="imgbox" @click="openImgPlugin()">
                            <el-image v-if="form.image" :src="typeof form.image === 'object' ? form.image.url : form.image" fit="cover"></el-image>
                            <i v-if="!form.image" class="el-icon-plus addicon"></i>
                            <div v-if="!form.image" class="text">添加图片</div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="积分价格：">
                    <el-input v-model.number="form.price" type="number" placeholder="请输入积分价格"></el-input>
                </el-form-item>
                <el-form-item label="可抵票数：">
                    <el-input v-model.number="form.vote_num" type="number" placeholder="请输入可抵票数"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogShow = false">取消</el-button>
                <el-button type="primary" @click="submitFun">确认</el-button>
            </div>
        </el-dialog>

        <!-- 图片选择器 -->
        <xsk-manage :managehide.sync="imgplugin.show" @confirm="imgpluginFun" :multiple="imgplugin.multiple"
            :count="imgplugin.count" is_rest>
        </xsk-manage>
    </div>
</template>

<script>
import baseTable from "@/components/common/baseTable.vue"

export default {
    name: 'CompetitionGift',
    components: {
        baseTable
    },
    data() {
        return {
            dialogShow: false,
            isEdit: false,
            editId: '',
            form: {
                name: '',
                image: '',
                price: 0,
                vote_num: 0,
                status: true,
                sort: 0
            },
            imgplugin: {
                show: false,
                multiple: false,
                count: 1,
                imgName: ''
            },
            search: {
                loading: false,
                total: 0,
                post: {
                    page: 1,
                    limit: 10
                },
                table: [],
                tableForm: [
                    { prop: 'id', label: 'ID', width: 60 },
                    { prop: 'name', label: '礼物名称', width: 150 },
                    { prop: 'image', label: '图片', width: 80 },
                    { prop: 'price', label: '积分抵扣', width: 100 },
                    { prop: 'vote_num', label: '可抵票数', width: 100 },
                    // { prop: 'status', label: '状态', width: 100 },
                    { prop: 'created_at', label: '添加时间', width: 180 },
                    { prop: 'operation', label: '操作', width: 120 }
                ]
            }
        }
    },
    created() {
        this.searchFun()
    },
    methods: {
        searchFun() {
            const _this = this
            _this.search.loading = true
            _this.axios.get('/api/sing/admin/gift/list', { params: _this.search.post }).then(res => {
                _this.search.loading = false
                if (res.code == 200) {
                    _this.search.table = res.data.data
                    _this.search.total = res.data.total
                }
            }).catch(() => {
                _this.search.loading = false
            })
        },
        handlePageChange(page) {
            this.search.post.page = page
            this.searchFun()
        },
        handleStatusChange(id, value) {
            const _this = this
            const status = value ? 1 : 0
            _this.axios.post(`/api/sing/admin/gift/status/${id}`, { status: status }).then(res => {
                if (res.code == 200) {
                    _this.$message.success(status == 1 ? '礼物已开启' : '礼物已关闭')
                    _this.searchFun()
                } else {
                    _this.$message.error(res.msg || '操作失败')
                }
            }).catch(err => {
                _this.$message.error('操作失败')
            })
        },
        addFun() {
            this.isEdit = false
            this.editId = ''
            this.form = {
                name: '',
                image: '',
                price: 0,
                vote_num: 0,
                status: true,
                sort: 0
            }
            this.dialogShow = true
        },
        editFun(row) {
            this.isEdit = true
            this.editId = row.id
            this.form = {
                name: row.name,
                image: row.image,
                price: row.price || 0,
                vote_num: row.vote_num || 0,
                status: row.status == 1,
                sort: row.sort || 0
            }
            this.dialogShow = true
        },
        deleteFun(row) {
            const _this = this
            _this.$confirm('确定要删除这个礼物吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.axios.post(`/api/sing/admin/gift/delete/${row.id}`).then(res => {
                    if (res.code == 200) {
                        _this.$message.success('删除成功')
                        _this.searchFun()
                    } else {
                        _this.$message.error(res.msg || '删除失败')
                    }
                }).catch(() => {
                    _this.$message.error('删除失败')
                })
            }).catch(() => {
                _this.$message.info('已取消删除')
            })
        },
        openImgPlugin() {
            this.imgplugin.show = true
            this.imgplugin.imgName = 'gift'
        },
        imgpluginFun(obj) {
            if (obj && obj.imgobjs && obj.imgobjs.length > 0) {
                // 保存完整的图片对象，包含url用于预览
                this.form.image = {
                    id: obj.imgobjs[0].id,
                    url: obj.imgobjs[0].url || obj.imgobjs[0].path || obj.imgobjs[0].src
                }
            }
        },
        submitFun() {
            const _this = this
            if (!_this.form.name) {
                _this.$message.error('请输入礼物名称')
                return
            }
            let data = {
                name: _this.form.name,
                price: _this.form.price || 0,
                vote_num: _this.form.vote_num || 0,
                status: _this.form.status ? 1 : 0,
                sort: _this.form.sort || 0
            }
            if (_this.form.image) {
                data.image = typeof _this.form.image === 'object' ? _this.form.image.id : _this.form.image
            }
            let url = _this.isEdit ? `/api/sing/admin/gift/edit/${_this.editId}` : '/api/sing/admin/gift/add'
            _this.axios.post(url, data).then(res => {
                if (res.code == 200) {
                    _this.$message.success(_this.isEdit ? '编辑成功' : '添加成功')
                    _this.dialogShow = false
                    _this.searchFun()
                } else {
                    _this.$message.error(res.msg || '操作失败')
                }
            }).catch(() => {
                _this.$message.error('操作失败')
            })
        }
    }
}
</script>

<style scoped>
.gift-rules {
    padding: 10px 15px;
    background: #f5f7fa;
    border-radius: 4px;
    margin-bottom: 20px;
    font-size: 12px;
    color: #666;
    line-height: 1.8;
}
.goodsimage {
    display: flex;
    flex-wrap: wrap;
}
.imgbox {
    width: 100px;
    height: 100px;
    border: 1px dashed #ddd;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
    position: relative;
}
.imgbox img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.addicon {
    font-size: 24px;
    color: #ccc;
}
.text {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
}
</style>